export const MEETING_TYPES = [
  { value: 'client_sync', label: 'Client Sync', titleTemplate: (client) => client ? `Sync with ${client}` : 'Client Sync' },
  { value: 'portfolio_review', label: 'Portfolio Review', titleTemplate: (client) => client ? `Portfolio Review — ${client}` : 'Portfolio Review' },
  { value: 'financial_plan', label: 'Financial Plan', titleTemplate: (client) => client ? `Financial Plan — ${client}` : 'Financial Plan Review' },
  { value: 'onboarding', label: 'Onboarding', titleTemplate: (client) => client ? `Onboarding — ${client}` : 'New Client Onboarding' },
  { value: 'quarterly_review', label: 'Quarterly Review', titleTemplate: (client) => client ? `Q${Math.ceil((new Date().getMonth() + 1) / 3)} Review — ${client}` : 'Quarterly Review' },
  { value: 'internal', label: 'Internal Meeting', titleTemplate: () => 'Internal Meeting' },
  { value: 'other', label: 'Other', titleTemplate: () => '' }
]

export const SUMMARY_TYPES = [
  {
    type: 'meeting_notes',
    label: 'Meeting Notes',
    prompt: 'Summarize this financial advisor meeting. Include a brief overview, key topics discussed, decisions made, action items with owners, and important client concerns.',
    defaultEnabled: true
  },
  {
    type: 'action_items',
    label: 'Action Items',
    prompt: 'Extract all action items from this meeting transcript. For each, include: the action, who is responsible, and any deadline mentioned. Format as a numbered list.',
    defaultEnabled: false
  },
  {
    type: 'crm_update',
    label: 'CRM Update',
    prompt: 'Write a concise CRM activity note for this meeting. Include: meeting purpose, key discussion points, client sentiment, and next steps. Keep it under 200 words.',
    defaultEnabled: false
  },
  {
    type: 'sentiment',
    label: 'Client Sentiment',
    prompt: 'Analyze the client sentiment in this meeting. Assess their overall satisfaction, any concerns raised, confidence level in the advisory relationship, and any risk of attrition.',
    defaultEnabled: false
  },
  {
    type: 'enhanced_notes',
    label: 'Enhanced Notes',
    prompt: 'You are given an advisor\'s hand-written notes and the full meeting transcript. Synthesize both into comprehensive, well-organized meeting notes. Prioritize the advisor\'s observations and add relevant detail and context from the transcript. Include: overview, key discussion points, decisions, action items with owners, and follow-ups. Where the advisor\'s notes highlight something, expand on it with transcript context.',
    defaultEnabled: false,
    hidden: true
  }
]

export const TERMINAL_STATUSES = ['completed', 'failed', 'cancelled']
